import React from "react";

export function WaveMark({ size = 40, light = false }) {
    return (
        <svg width={size} height={size} viewBox="0 0 64 64" data-testid="brand-wave-mark" aria-hidden="true">
            <rect width="64" height="64" rx="14" fill={light ? "#F3EDE2" : "#0F2837"} />
            <path d="M10 40c6-6 12-6 18 0s12 6 18 0 8-6 10-4" fill="none" stroke="#C49A45" strokeWidth="3.5" strokeLinecap="round" />
            <path d="M10 48c6-6 12-6 18 0s12 6 18 0 8-6 10-4" fill="none" stroke={light ? "#0F2837" : "#F3EDE2"} strokeWidth="3" strokeLinecap="round" opacity="0.7" />
            <circle cx="46" cy="18" r="6" fill="#C49A45" />
        </svg>
    );
}

export function MaskedLine({ children, delay = 0, as: Tag = "span" }) {
    return (
        <span className="mask-line revealed" style={{}}>
            <span style={{ transitionDelay: `${delay}ms` }}>{children}</span>
        </span>
    );
}
